<template>
    <!--手勢下滑關閉-->
    <PullDownClose @close="cancel" class="bank-card">
        <div class="content">
            <div class="fixed-pop-title">付款方式</div>
            <el-radio-group v-model="paymentSelected" @change="confirmClick()" class="bank-list">
                <template v-for="(option, index) in paymentList" >
                    <div :key="index" class="con" :id="option.type" v-if="option.status!==0">
                        {{option.status}}
                        <el-radio v-if="option.status" :label="(option.type === 'tokenPayNewebpayMPG' ? `${option.id}-${option.type}-${option.userPayTokenId}` : option.id)">
                            <img :src="getIcon(option.imagePath)" />
                            {{ option.name }}
                            <div class="ps" v-if="option.type === 'tokenPayNewebpayMPG'">
                                <span>{{option.payTokenName}}</span>
                                <span v-if="option.card4No !== ''">*{{option.card4No}}</span>
                            </div>
                        </el-radio>
                        <template v-if="option.status && option.type === 'newebpayMPG'">
                            <el-radio v-for="option2 in option.instFlag" :key="option2.id"
                                      :label="option.id + '-' + option2">
                                <template v-if="option2 === '0'">
                                    <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')"/>
                                    信用卡
                                </template>
                                <template v-else-if="option2 === '100'">
                                    <img :src="require('@/assets/images/pay/other_pay_googlepay.svg')"/>
                                    Google Pay
                                </template>
                                <template v-else-if="option2 === '101'">
                                    <img :src="require('@/assets/images/pay/other_pay_samsungpay.svg')"/>
                                    Samsung Pay
                                </template>
                                <template v-else>
                                    <img :src="require('@/assets/images/pay/other_pay_credit_card2.svg')"/>
                                    信用卡分期 - {{ option2 }} 期
                                </template>
                            </el-radio>
                        </template>


                    </div>
                </template>


                <!--todo 價錢大於零樣式加red-->
                <!--<el-radio label="1" class="bank-list" v-if="false">
                        <img src="@/assets/images/card-visa.svg" alt="visa">
                        <div class="bank">
                            <div class="name">台新國際商業銀行</div>
                            <div class="account">1234-5617-****-**36</div>
                        </div>
                        <span class="more">切換信用卡 <i class="el-icon-arrow-right"/></span>
                    </el-radio>-->
                <!-- <el-radio label="1"><img src="@/assets/images/other_pay_cash.svg">現金</el-radio> -->
                <!-- <el-radio label="20"><img src="@/assets/images/other_pay_credit_card2.svg">信用卡</el-radio> -->
                <!--<el-radio label="3"><img src="@/assets/images/other_pay_linepay2.svg">LINE PAY</el-radio>
                    <el-radio label="4"><img src="@/assets/images/other_pay_easywallet2.svg">悠遊付</el-radio>
                    <el-radio label="5"><img src="@/assets/images/other_pay_pi2.svg">Pi錢包</el-radio>
                    <el-radio label="6"><img src="@/assets/images/other_pay_credit_card2.svg">支付寶</el-radio>
                    <el-radio label="7"><img src="@/assets/images/other_pay_wechatpay2.svg">微信支付</el-radio>-->
            </el-radio-group>
            <!--<el-button type="warning" @click="confirmClick()" class="bottom-btn">
                    確定
            </el-button>-->
        </div>
    </PullDownClose>
</template>

<script>
import PullDownClose from "../../../components/PullDownClose";
import * as constDefine from "@/store/constDefine";
export default {
    name: "BankCard",
    props: {
        paymentType: {},
        objectType: {type: Number, default: 0},            //
        objectId: {type: Number, default: 0},            //
        funcTypeId: {type: Number, default: 0},            //
    },
    components: {
        PullDownClose,
    },
    data() {
        return {
            paymentSelected: 0,
            storeId: Number(this.$route.query.storeId ? this.$route.query.storeId : this.$store.state.cartStoreId),//店家id(query過來的是修改訂單)
            paymentList: '',
            isLogin: this.$auth.isAdminLogin(),
            isCordova: this.$public.isCordova(),
            isAppOpen: false,
        }
    },
    created() {
        if (!this.isCordova) {
            try {
                let dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));
                if (this.storeId === 0 && dataObject.isChecked) {
                    this.storeId = Number(dataObject.storeId);
                }

                this.isAppOpen = dataObject?.isAppOpen || false
            } catch (e) {
               //
            }
        }

        if (this.paymentType.type === "newebpayMPG") {
            this.paymentSelected = this.paymentType.id + "-" + this.paymentType.selectFlag
        } else if (this.paymentType.type === "tokenPayNewebpayMPG") {
            this.paymentSelected = this.paymentType.id + "-" + this.paymentType.type + "-" + this.paymentType.userPayTokenId
        } else {
            this.paymentSelected = this.paymentType.id
        }

        if (this.isLogin) {
            //載入店家此功能金流支付
            this.setupData();
        } else {
            this.$emit('callback', true);
        }
    },
    mounted() {


    },
    methods: {
        setupData() {
            let self = this;

            if (this.objectType !== 0 && this.objectId !== 0 ) {
                this.$store.commit('setCartStoreId',0 );
                this.storeId = 0;
            }

            this.$http.fetchWithAuth`GetPaymentList${{
                storeId: self.storeId,
                objectType: self.objectType,        //支付類型, 0現金 1信用卡 2其他 3線上付款(金流，藍新、綠界), 4?
                objectId: self.objectId,            //商圈ID
                funcTypeId: self.funcTypeId,        //1預訂, 4表單購物車結帳, 5:商圈購物車結帳, 6:商品QRcode結帳
                isCordova: self.isCordova,
                isAppOpen: self.isAppOpen,
            }}
            ${json => {
                if (json.status) {
                    self.paymentList = json.data;
                }
            }}`;
        },


        getIcon(icon) {
            if (icon !== "") {
                try {
                    return require('@/assets/images/pay/' + icon)
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.log(error)
                }
            }
        },
        confirmClick() {
            if (this.paymentSelected === "") {
                this.$public.showNotify("請選擇付款方式", false);
                return false
            }
            this.paymentList.slice().some(e => {
                //整理信用卡分期選項的資料格式是"135-3"
                var getData = ''
                const isCheck = this.paymentSelected.toString().indexOf("-")
                if (isCheck > 0) {
                    getData = this.paymentSelected.slice().split("-")
                    if (e.id === Number(getData[0])) {
                        if(e.type === "tokenPayNewebpayMPG" && getData[1] === "tokenPayNewebpayMPG") {
                            if(Number(getData[2]) === e.userPayTokenId) {
                                e.selectFlag = 0
                                this.$emit('changePaymentType', e);
                                return true
                            }
                        } else if (e.type === "newebpayMPG") {
                            e.selectFlag = Number(getData[1])
                            this.$emit('changePaymentType', e);
                            return true
                        }
                    }

                } else {
                    getData = this.paymentSelected
                    if (e.id === getData) {
                        e.selectFlag = 0;
                        this.$emit('changePaymentType', e);
                        return true
                    }
                }

            })
        },
        cancel() {
            // //點空白處關閉
            this.$emit('changePaymentType', '');
        },
    }
}
</script>
